import { Base } from '@gandi/ui';
import { DetailRow } from './DetailRow';
import { TitleRow } from './TitleRow';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
var styles = {
  "root": "ContentRow-root_13XUe"
};
export function ContentRow({
  details,
  title
}) {
  return /*#__PURE__*/_jsxs("div", {
    className: styles.root,
    children: [/*#__PURE__*/_jsx(TitleRow, {
      title: title
    }), details.length > 0 && /*#__PURE__*/_jsx(Base, {
      tagName: "ul",
      margin: "none",
      padding: "none",
      listStyleType: "none",
      children: details.map(props => /*#__PURE__*/_jsx(DetailRow, {
        ...props
      }, props.label))
    })]
  });
}